export const APP = {
  name: "Succeschool",
  tagline: "Succeschool Educational Platform",
  email: "contact@succeschool.fr",
  website: "www.succeschool.fr",
  cgu: "https://succeschool-soutien.fr/conditions-generales-de-vente/",
  rules: "https://succeschool-soutien.fr/reglement-interieur/",
  pageSize: 50,
  /** Max file size for uploads in bytes (100 MB) */
  MAX_FILE_SIZE: 100 * 1024 * 1024,
  /** Max image size for uploads in bytes (100 MB) */
  MAX_IMAGE_SIZE: 100 * 1024 * 1024,
} as const;
